<template>
    <div>
        <div class="container">
            <div class="row mt-5">
                <div class="col-md-4 col-12">
                    <h3>Settings</h3>
                </div>
                <div class="col-md-8 col-12">
                    <ul class="nav nav-tabs nav-settings">
                        <li @click="showBio" class="nav-item">
                            <router-link class="nav-link" to="?bio">Bio</router-link>
                        </li>
                        <!-- <li @click="showCard" class="nav-item">
                            <router-link class="nav-link" to="?payment">Payment</router-link>
                        </li> -->
                        <li @click="showHandle" class="nav-item">
                            <router-link class="nav-link" to="?handle">Handle</router-link>
                        </li>
                        <li @click="showLocation" class="nav-item">
                            <router-link class="nav-link" to="?location">Location</router-link>
                        </li>
                        <li @click="showPassword" class="nav-item">
                            <router-link class="nav-link" to="?passwords">Passwords</router-link>
                        </li>
                        <li @click="showPrivacy" class="nav-item">
                            <router-link class="nav-link" to="?privacy">Privacy</router-link>
                        </li>
                    </ul>
                </div>  
            </div>
        </div>

        <!-- will work on referrals next! -->

        <!-- bio data settings here -->
        <app-bio-data @gotoHandle="showHandle" @gotoPrivacy="showPrivacy" v-if="bioTab"></app-bio-data>
        
        <!-- banking settings here -->
        <app-card v-if="cardTab"></app-card>
        
        <!-- handle settings here -->
        <app-handle v-if="handleTab"></app-handle>
        
        <!-- password settings here -->
        <app-password v-if="passwordTab"></app-password>
        
        <!-- location settings here -->
        <app-location v-if="locationTab"></app-location>
        
        <!-- privacy settings here -->
        <app-privacy v-if="privacyTab"></app-privacy>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

import BioData from './settingsParts/BioData.vue'
import Card from './settingsParts/Card.vue'
import Handle from './settingsParts/Handle.vue'
import Password from './settingsParts/Password.vue'
import Location from './settingsParts/Location.vue'
import Privacy from './settingsParts/Privacy.vue'
import LayoutUser from '@/layouts/User.vue'

export default {
    name: "Setting",
    data() {
        return {
            bioTab: true,
            cardTab: false,
            handleTab: false,
            privacyTab: false,
            passwordTab: false,
            locationTab: false
        }
    },
    methods: {
        showBio() {
            this.closeAllTabs()
            this.bioTab = true
        },
        showCard() {
            this.closeAllTabs()
            this.cardTab = true
        },
        showHandle() {
            this.closeAllTabs()
            this.handleTab = true
        },
        showPrivacy() {
            this.closeAllTabs()
            this.privacyTab = true
        },
        showPassword() {
            this.closeAllTabs()
            this.passwordTab = true
        },
        showLocation() {
            this.closeAllTabs()
            this.locationTab = true
        },
        closeAllTabs() {
            this.bioTab = false
            this.cardTab = false
            this.handleTab = false
            this.privacyTab = false
            this.locationTab = false
            this.passwordTab = false
        }
    },
    computed: {
        ...mapGetters(['user'])
    },
    components: {
        appCard: Card,
        appHandle: Handle,
        appBioData: BioData,
        appPrivacy: Privacy,
        appPassword: Password,
        appLocation: Location,
    },
    created() {
        // if create handle is requested
        if(this.$route.query.handle === null){ this.showHandle() }
        if(this.$route.query.payment === null){ this.showCard() }
        if(this.$route.query.privacy === null){ this.showPrivacy() }
        if(this.$route.query.location === null){ this.showLocation() }
        if(this.$route.query.passwords === null){ this.showPassword() }

        this.$emit('update:layout', LayoutUser);
    }
}
</script>